<script>
    import InfiniteLoading from 'vue-infinite-loading'
    import SearchViewMap from './SearchViewMap'
    import SearchViewFiltersContainer from './SearchViewFiltersContainer'
    import SearchViewResultCourseContainer from './SearchViewResultCourseContainer'

    export default {
        props: ['source'],
        components: {
            SearchViewMap,
            InfiniteLoading,
            SearchViewFiltersContainer,
            SearchViewResultCourseContainer
        },
        data() {
            return {
                geoerrormessage: null,
                filtersSource: '/filterCourses',
                infiniteId: +new Date(),
                items: [],
                pagination: {},
                filters: {},
                page: 1,
                defaultView: 'list',
                latitude: null,
                longitude: null,
                viewInfinite: false,
                distance: 100,
                mobileDetect: window.innerWidth < 1000,
            }
        },
        mounted() {
            this.$bus.$on('update-filters', this.updateFilters)
            this.$bus.$on('update-view', (view) => {
                this.switchView(view)
            })
            this.latitude = this.getParameterByName('latitude')
            this.longitude = this.getParameterByName('longitude')

            let view = this.getParameterByName('view')
            if (view) {
                this.switchView(view)
            }

            window.onresize = () => {
              console.log(window.innerWidth)
              this.$set(this, 'mobileDetect', window.innerWidth < 1000)
            }
        },
        updated() {
            this.updateOwl()
        },
        methods: {
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.returnPosition, this.errorPosition);
                } else {
                    this.geoerrormessage = 'Attenzione: le distanze non sono disponibili, in quanto non è stata attivata la geolocalizzazione'
                }
            },
            returnPosition(position) {
                this.geoerrormessage = null

                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;

                this.updateFilters(this.filters)
            },
            errorPosition(error) {
                this.geoerrormessage = 'Attenzione: le distanze non sono disponibili, in quanto non è stata attivata la geolocalizzazione'

                this.latitude = 0;
                this.longitude = 0;

                this.updateFilters(this.filters)
            },
            switchView(view) {
                this.$set(this, 'defaultView', view)
            },
            updateFilters(filters) {
                this.$set(this, 'filters', filters)
                this.$set(this, 'filtersSource', '/filterCourses')
                this.$set(this, 'pagination', {})
                this.$set(this, 'page', 1)
                this.$set(this, 'items', [])

                // this.infiniteId += 1
                // this.infiniteHandler(this.$refs.loading.stateChanger)
                // this.infiniteId += 1
                this.fetchFilters()

                this.$bus.$emit('map-filters', {
                    filters,
                    search_string: this.search_string
                })
            },
            manualLoad() {
                this.distance = 100;

                this.$set(this, 'filtersSource', '/filterCourses')
                this.$nextTick(() => {
                    this.$refs.loading.attemptLoad();
                });
            },
            infiniteHandler($state) {
                if (!this.latitude || !this.longitude) {
                    this.getLocation();
                } else {
                    if (! _.isEmpty(this.pagination)) {
                        if (this.pagination.current_page === this.pagination.last_page) {
                            $state.complete()
                        } else {
                            this.fetch($state)
                        }
                    } else {
                        this.fetch($state)
                    }
                }
            },
            fetch($state) {
                let filters = Object.assign(this.filters, {
                    municipality: this.getParameterByName('municipality')
                })

                axios.get(this.filtersSource, {
                    params: {
                        filters: filters,
                        latitude: this.latitude,
                        longitude: this.longitude,
                        search_string: this.getParameterByName('search_string'),
                        page: this.page
                    }
                }).then(({data}) => {
                    const is_municipality = data.is_municipality

                    if (is_municipality) {
                        this.geoerrormessage = 'Attenzione: le distanze sono calcolate dal centro della località inserita'
                    }

                    let results = data.results

                    let temp = this.items

                    this.$set(this, 'items', temp.concat(results.data))

                    this.$bus.$emit('update-count', {
                        count: results.total
                    });
                    this.$set(this, 'page', results.current_page + 1)
                    this.$set(this, 'pagination', _.omit(results, ['data']))

                    if (results.data.length > 0) {
                        $state.loaded()
                        if (results.data.length > 19) {
                            this.distance = -Infinity
                        }
                    } else {
                        $state.complete()
                    }
                }).catch((error) => {
                    this.$bus.$emit('filtered', null);
                    window.alerts.error("Si è verificato un errore con la tua ricerca");
                    $state.complete()
                })
            },
            fetchFilters() {
                let filters = Object.assign(this.filters, {
                    municipality: this.getParameterByName('municipality')
                })
                axios.get(this.filtersSource, {
                    params: {
                        filters: filters,
                        latitude: this.latitude,
                        longitude: this.longitude,
                        search_string: this.getParameterByName('search_string'),
                        page: this.page
                    }
                }).then(({data}) => {
                    let results = data.results

                    let temp = this.items

                    this.$set(this, 'items', temp.concat(results.data))

                    this.$bus.$emit('update-count', {
                        count: results.total
                    });
                    this.$set(this, 'page', results.current_page + 1)
                    this.$set(this, 'pagination', _.omit(results, ['data']))

                }).catch((error) => {
                    this.$bus.$emit('filtered', null);
                    window.alerts.error("Si è verificato un errore con la tua ricerca");
                })
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');

                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            updateOwl() {
                $('.owl-prev').each(function() {
                    var slider_left = $(this).find('span')
                    $(slider_left).empty()
                    $(slider_left).append('<img src="/images/left-arrow.svg" alt="">')
                })
                $('.owl-next').each(function() {
                    var slider_right = $(this).find('span')
                    $(slider_right).empty()
                    $(slider_right).append('<img src="/images/icons/white-rounded-bg-right-arrow-icon.svg" alt="">')
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchViewContainer.vue